<template>
  <el-dialog
    title="申请使用"
    :visible.sync="dialogVisible"
    :append-to-body="true"
    :width="width || '420px'"
    class="el-dialog-opc"
  >
    <div class="merchants-form merchants-form-use">
      <el-form ref="form" :model="form" :rules="rules" label-position="top">
        <el-form-item style="width: 100%" prop="mobile">
          <el-input v-model="form.mobile" placeholder="输入手机号"></el-input>
        </el-form-item>
        <el-form-item prop="captcha">
          <div class="verification-card">
            <div class="verification-card-inpupt flex-fill">
              <el-input v-model="form.captcha" placeholder="输入验证码"></el-input>
            </div>
            <div class="verification-card-btn" @click="getCode" :disabled="captchaDisabled">
              {{ captchaText }}
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button class="join-btn" type="primary" @click.stop.prevent="save">立即提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import api from '@/api'
import { mapState } from 'vuex'
import { phone } from '@/utils/validation'
export default {
  name: 'App',
  data() {
    return {
      dialogVisible: false,
      form: {
        name: '',
        mobile: '',
        captcha: ''
      },
      rules: {
        name: [{ required: true, message: '请输入真实姓名', trigger: 'blur' }],
        mobile: [{ required: true, validator: phone, trigger: 'blur' }],
        captcha: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { min: 4, max: 4, message: '验证码错误，请重新输入', trigger: 'blur' }
        ]
      },
      timer: 0,
      captchaText: '获取验证码',
      captchaDisabled: false,
      query: {
        invitorName: '',
        domainName: '',
        domainLogo: ''
      }
    }
  },
  props: ['width'],
  methods: {
    init() {
      this.dialogVisible = true
    },
    getCode() {
      // if (this.$route.qu)
      this.$refs.form.validateField('mobile', res => {
        if (!res) {
          this.sendCode()
        }
      })
    },
    save() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.activeLoading = true
          let params = {
            mobile: this.form.mobile,
            code: this.form.captcha
          }
          await api.dealApplyPlatform(params)
          this.resetCaptcha()
          this.activeLoading = false
          this.dialogVisible = false
          this.$root.$refs.tipSuccess.init()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    sendCode() {
      api
        .sendApplyPlatformCode({
          mobile: this.form.mobile
        })
        .then(res => {
          if (res.data) {
            this.initInterval(res.data)
          } else {
            this.initInterval(120)
          }
        })
    },
    initInterval(val) {
      this.captchaDisabled = true
      this.timer = Number(val)
      this.captchaText = '（' + this.timer + 's）'
      this.myInterval = setInterval(() => {
        if (this.timer === 0) {
          this.resetCaptcha()
        } else {
          this.timer = this.timer - 1
          this.captchaText = '（' + this.timer + 's）'
        }
      }, 1000)
    },
    resetCaptcha() {
      this.captchaDisabled = false
      this.captchaText = '获取验证码'
      clearInterval(this.myInterval)
    }
  },
  computed: {
    ...mapState([])
  },
  components: {},
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.init(to, from)
    })
  },
  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    next()
  }
}
</script>

<style scoped lang="scss">
$primary: #4876f9;
.join-btn {
  width: 100%;
  padding: 16px 20px;
  font-size: 20px;
  margin-top: 10px;

  &:hover {
    background: #3462e5;
  }
}
.verification-card {
  // display: flex;
  position: relative;
}
.verification-card-btn {
  width: 7rem;
  text-align: center;
  height: 54px;
  line-height: 54px;
  color: $primary;
  font-size: 0.88rem;
  margin-left: 0.75rem;
  border-radius: 0.25rem;
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
}
.merchants-form {
  width: auto;
  margin-top: -20px;
}
</style>



// WEBPACK FOOTER //
// src/modules/common/applyForUse.vue